import React from "react";
import { useTranslation } from "react-i18next";

import teamImg1 from "../../assets/images/team/Imagen1.png";
import teamImg2 from "../../assets/images/team/Imagen2.png";
import teamImg3 from "../../assets/images/team/Imagen3.png";
import teamImg4 from "../../assets/images/team/Imagen4.png";
import teamImg6 from "../../assets/images/team/team-06.jpg";
import teamImg7 from "../../assets/images/team/team-07.jpg";
import teamImg8 from "../../assets/images/team/team-08.jpg";
import teamImg9 from "../../assets/images/team/team-09.jpg";
import teamImg10 from "../../assets/images/team/team-10.jpg";
import teamImg11 from "../../assets/images/team/team-11.jpg";

const TeamData = () => {
  const { t } = useTranslation();

  const data = [
    {
      images: teamImg1,
      title: t("usa"),
      designation: <a href="mailto:usa@bsslate.com">usa@bsslate.com</a>,
      socialNetwork: [],
    },
    {
      images: teamImg2,
      title: t("mexico"),
      designation: <a href="mailto:mexico@bsslate.com">mexico@bsslate.com</a>,
      socialNetwork: [],
    },
    {
      images: teamImg3,
      title: t("colombia"),
      designation: <a href="mailto:colombiao@bsslate.com">colombia@bsslate.com</a>,
      socialNetwork: [],
    },
    {
      images: teamImg4,
      title: t("republica dominicana"),
      designation: <a href="mailto:dominicana@bsslate.com">dominicana@bsslate.com</a>,
      socialNetwork: [],
    },
    {
      images: teamImg6,
      title: t("extraccion"),
      designation: t(),
      socialNetwork: [],
    },
    {
      images: teamImg7,
      title: t("seleccion"),
      designation: t(),
      socialNetwork: [],
    },
    {
      images: teamImg8,
      title: t("fabricacion"),
      designation: t(),
      socialNetwork: [],
    },
    {
      images: teamImg9,
      title: t("logistica"),
      designation: t(),
      socialNetwork: [],
    },
    {
      images: teamImg10,
      title: t("Distribuidores"),
      designation: t(),
      socialNetwork: [],
    },
    {
      images: teamImg11,
      title: t("cliente"),
      designation: t(),
      socialNetwork: [],
    },
  ];

  return data;
};

export default TeamData;
